module.exports = __webpack_public_path__ + "img/milk-food.87256d7c.svg";